'use es6';

import http from 'hub-http/clients/apiClient';
import { formatOwners } from 'reference-resolvers/formatters/formatOwners';
import formatUsers from 'reference-resolvers/formatters/formatUsers';
import { formatUsersV2Map } from 'reference-resolvers/formatters/formatUsersV2';
import { formatUsersSearchPaged } from 'reference-resolvers/formatters/formatUsersSearch';
import { Map as ImmutableMap } from 'immutable';
import get from 'transmute/get';
const formatResponse = response => {
  return ImmutableMap({
    owners: formatOwners(response),
    users: formatUsers(response)
  });
};
export const createGetAllUsers = ({
  httpClient,
  portalId
}) => () => httpClient.get('owners/v2/owners', {
  query: Object.assign({
    contactsOnly: true
  }, portalId && {
    portalId
  })
}).then(formatResponse);
export const getAllUsers = createGetAllUsers({
  httpClient: http
});
export const createGetUsersByIds = ({
  httpClient,
  portalId
}) => ids => httpClient.put('users/v2/app/hub-users/bulk', {
  data: portalId ? {
    ids,
    portalId
  } : ids,
  query: Object.assign({
    limit: ids.length
  }, portalId && {
    portalId
  })
}).then(get('userBriefs')).then(formatUsersV2Map);
export const getUsersByIds = createGetUsersByIds({
  httpClient: http
});
export const createFetchUsersSearchPage = ({
  httpClient,
  portalId
}) => props => {
  const {
    count,
    offset,
    query
  } = props.toJS();
  return httpClient.put('users-search/v1/users-search/app/search', {
    data: Object.assign({
      limit: count,
      offset,
      searchQuery: query
    }, portalId && {
      portalId
    }),
    query: Object.assign({}, portalId && {
      portalId
    })
  });
};
export const fetchUsersSearchPage = createFetchUsersSearchPage({
  httpClient: http
});
export const createGetUsersSearchPage = options => {
  const getter = createFetchUsersSearchPage(options);
  return props => getter(props).then(formatUsersSearchPaged);
};
export const getUsersSearchPage = props => {
  return fetchUsersSearchPage(props).then(formatUsersSearchPaged);
};